import { useEffect, useState } from "react";
import { sectionNav } from "@/mocks/community";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = sectionNav.slice(0, 6);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center font-label text-lg transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            黑
          </span>
          <span
            className={`font-label text-xl tracking-wide transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            黑料
            <span
              className={`ml-2 text-xs font-sans font-normal tracking-normal ${
                scrolled ? "text-foreground-500" : "text-background-100/80"
              }`}
            >
              吃瓜情报站
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden sm:inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-notification-3-line" />
            订阅吃瓜
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((v) => !v)}
            className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              scrolled
                ? "text-foreground-800 hover:bg-background-100"
                : "text-background-50 hover:bg-white/10"
            }`}
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {mobileOpen ? (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 pb-4">
          <nav className="grid grid-cols-2 gap-2 pt-2">
            {sectionNav.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-700 bg-background-100 rounded-md hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setMobileOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 bg-primary-500 text-background-50 text-sm font-medium px-4 py-2.5 rounded-md cursor-pointer"
          >
            <i className="ri-notification-3-line" />
            订阅吃瓜
          </a>
        </div>
      ) : null}
    </header>
  );
}